<template>
    <div v-if="accessoryData.length > 0">
        <h4 class="h4 accessory-list-title" v-if="label">{{ label }}</h4>
        <template v-for="accessoryType in accessoryData">
            <h5>{{ accessoryType.title }}</h5>
            <form-checkbox
                v-for="option in accessoryType.options"
                :ref="'accessory-control-' + option.id"
                :key="option.id"
                :value="accessoryIds.indexOf(option.id) !== -1"
                @input="onChange(option.id, $event)"
                :name="option.id"
                class="checkbox--third"
            >
                <span v-html="$options.filters.m2(option.area)"/>
                <span v-if="option.price">, {{ option.price.withVat | numberFormat | currencySymbol }}</span>
                <span class="successful-update"></span>
            </form-checkbox>
        </template>
    </div>
</template>

<script>
import FormCheckbox from 'domovio-core/src/components/Form/Input/FormCheckbox';

export default {
    name:       'AccessoryPickerList',
    components: {FormCheckbox},
    props:      {
        label:         {
            type:     String,
            required: false,
        },
        accessoryData: {
            type:     Array,
            required: true,
        },
    },
    computed:   {
        accessoryIds() {
            return this.$store.getters['projects/project/units/unit/accessoryIds'];
        }
    },
    methods:    {
        onChange(accessoryId, connected) {
            this.$emit('change', {accessoryId, connected});
        }
    }
}
</script>
